(function () {
  var STORAGE_DISMISS = 'v2g_popup_dismiss_until';
  var STORAGE_CLAIMED = 'v2g_popup_claimed';
  var DELAY_MS = 30000;
  var SCROLL_TRIGGER = 0.5;
  var DISMISS_DAYS = 30;

  var currentScript = document.currentScript;
  var copiedText = currentScript ? currentScript.dataset.copiedText : 'Copied!';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var popup = document.getElementById('v2g-popup');
    if (!popup) return;

    if (popup.dataset.alreadySubscribed === 'true') return;

    var form = document.getElementById('v2g-popup-form');
    var formState = popup.querySelector('[data-v2g-popup-form-state]');
    var successState = popup.querySelector('[data-v2g-popup-success]');
    var errorEl = popup.querySelector('[data-v2g-popup-error]');
    var lastFocused = null;
    var timer = null;

    // The form is a real native POST (full page reload) — see the Liquid
    // file for why. On the reloaded page, Shopify's form object tells us
    // via server-rendered markup whether THIS submission just succeeded or
    // failed, so re-open the popup immediately showing that result instead
    // of waiting for the normal delay/dismiss-check flow below.
    var justSucceeded = !!document.getElementById('v2g-popup-success-marker');
    var justErrored = !!(errorEl && !errorEl.hidden && errorEl.textContent.trim());

    if (justSucceeded) {
      formState.hidden = true;
      successState.hidden = false;
      try {
        localStorage.setItem(STORAGE_CLAIMED, '1');
      } catch (e) {
        /* ignore */
      }
      openPopup();
    } else if (justErrored) {
      openPopup();
    } else {
      try {
        if (localStorage.getItem(STORAGE_CLAIMED) === '1') return;
        var dismissUntil = localStorage.getItem(STORAGE_DISMISS);
        if (dismissUntil && Date.now() < Number(dismissUntil)) return;
      } catch (e) {
        /* localStorage unavailable — fall through and show anyway */
      }
      // Not while someone is choosing a product: the popup would cover the buy box.
      if (document.querySelector('[data-v2g-e-add],[data-v2g-im-add],[data-v2g-dr-add],[data-v2g-vp-add]')) return;
      // Open after 30 seconds, or once the visitor has read half of the page.
      var armed = true;
      function fire() {
        if (!armed) return;
        armed = false;
        clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
        openPopup();
      }
      function onScroll() {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && window.scrollY / h >= SCROLL_TRIGGER) fire();
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      timer = setTimeout(fire, DELAY_MS);
    }

    function onKeydown(e) {
      if (e.key === 'Escape') closePopup(true);
    }

    function openPopup() {
      lastFocused = document.activeElement;
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        popup.classList.add('is-open');
        var emailInput = form && form.querySelector('input[type=email]');
        // Focusing the field on a phone pops the keyboard over the offer.
        if (emailInput && !window.matchMedia('(pointer: coarse)').matches) emailInput.focus();
      });
      document.addEventListener('keydown', onKeydown);
    }

    function closePopup(remember) {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKeydown);
      setTimeout(function () {
        popup.hidden = true;
      }, 250);
      if (remember) {
        try {
          localStorage.setItem(STORAGE_DISMISS, String(Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000));
        } catch (e) {
          /* ignore */
        }
      }
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    popup.querySelectorAll('[data-v2g-popup-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closePopup(true);
      });
    });

    var copyBtn = popup.querySelector('[data-v2g-popup-copy]');
    var codeEl = popup.querySelector('[data-v2g-popup-code]');
    if (copyBtn && codeEl) {
      var originalText = copyBtn.textContent;
      copyBtn.addEventListener('click', function () {
        var text = codeEl.textContent.trim();
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(text).then(function () {
          copyBtn.textContent = copiedText;
          setTimeout(function () {
            copyBtn.textContent = originalText;
          }, 2000);
        });
      });
    }
  });
})();
